/*添加服务*/
define('services/mysetting/invoice.service',['app'], function (app) {
    return app.factory('invoiceService', ['ngDialog', '$state', 'OpenApp', 'auiDialog','OpenUp','UserInfo',
        function (ngDialog, $state, OpenApp, auiDialog,OpenUp,UserInfo) {

        var receiptRes;
        function getInvoiceInfoCache(callback){
            if(receiptRes && receiptRes.receipt){
                callback(receiptRes);
            }else{
                OpenUp.getReceiptInfo({req:{}}).then(function (res) {
                    receiptRes = res;
                    callback(res);
                }).catch(function(res){
                    callback(res);
                });
            }

        }
        function getInvoiceInfo(callback){
            OpenUp.getReceiptInfo({req:{}}).then(function (res) {
                receiptRes = res;
                callback(res);
            }).catch(function(res){
                callback(res);
            });
        }

        function createReceipt(argObj,callback){
            OpenUp.createReceipt(argObj).then(function(res){
                callback(res);
            }).catch(function(res){
                callback(res);
            });
        }

        function createReceiptForIndiv(argObj, callback) {
            OpenUp.createReceiptForIndiv(argObj).then(function (res) {
                callback(res);
            }).catch(function (res) {
                callback(res);
            });
        }

        function getNotifyMessage(callback){
			OpenUp.getNotifyMessage({
				"req":{displayPosition:3}
			}).then(function(res){
				if(res && res.resultCode===0){
					callback(res.message);
				}
			});
        }
        
          function getContactInfo(callback) {
              UserInfo.getMerchantContactList().then(function (res) {
                var contactInfo = {};
                if (res && res.contactInfo) {
                    contactInfo = res.contactInfo;
                    callback(contactInfo);
                }
            });
        }

        
        return {
            'getInvoiceInfo' : getInvoiceInfo,
            'createReceipt': createReceipt,
            'createReceiptForIndiv': createReceiptForIndiv,
            'getContactInfo': getContactInfo,
            'getNotifyMessage':getNotifyMessage,
            'getInvoiceInfoCache':getInvoiceInfoCache
        }
    }]);
});

